'use strict';

import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Loader from '@uw-it-sis/lib-react/lib/Loader';

import FacetsPanel from './FacetsPanel';

/**
 * Facets Modal UI Component
 */

class FacetsModal extends Component {

    constructor(props) {
        super(props);
        this.props = props;

        this.state = {
            showModal: false
        };

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
    }

    close = () => this.setState({showModal: false});

    open = () => this.setState({showModal: true});

    render() {

        let filterCount = 0;

        // Get a count of the selected filters to show on small devices
        if (this) {
            this.props.facets.map( function(facetModel, i) {
                if (facetModel) {
                    let filterModel = facetModel.props.facetModel.filterModels;
                    Object.keys(filterModel).forEach( function(facet, i) {
                        if (filterModel[facet].selected) {
                            filterCount++;
                        }
                    });
                }
            });
        }

        return (
            <>
                <Button onClick={this.open} size="sm" className="d-print-none d-lg-none">
                    Filters {filterCount > 0 ? '('+filterCount+')' : ''}
                </Button>

                <Modal id="modal-facet-filters"
                       show={this.state.showModal}
                       onHide={this.close}
                       size="sm"
                       aria-labelledby="modal-facet-filters-title"
                       centered>
                    <Modal.Header closeButton>
                        <Modal.Title id="modal-facet-filters-title">Filters</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Loader show={this.props.showLoader} message={this.props.loaderMessage}>
                            <FacetsPanel facets={this.props.facets} headerText="Facets" showHeader={false}/>
                        </Loader>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.close}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

FacetsModal.propTypes = {
    loaderMessage: PropTypes.string.isRequired,
    facets: PropTypes.array.isRequired,
    showLoader: PropTypes.bool.isRequired
};

export default FacetsModal;
